import { cn } from '@/lib/utils';

interface ImgPlaceholderProps {
	label: string;
	height?: number;
	className?: string;
	tone?: 'purple' | 'gold';
}

export function ImgPlaceholder({
	label,
	height = 160,
	className,
	tone = 'purple',
}: ImgPlaceholderProps) {
	const fg = tone === 'gold' ? 'rgba(255,140,0,0.25)' : 'rgba(131,1,196,0.28)';
	return (
		<div
			className={cn(
				'flex items-center justify-center rounded-lg border border-loomlite-border text-[11px] uppercase tracking-[0.05em] text-loomlite-dim',
				className,
			)}
			style={{
				height,
				fontFamily: 'ui-monospace, "SF Mono", Menlo, monospace',
				background: `repeating-linear-gradient(135deg, ${fg} 0 2px, transparent 2px 12px), var(--color-loomlite-card-alt)`,
			}}
		>
			{label}
		</div>
	);
}
